import { render, staticRenderFns } from "./review-affiliation.vue?vue&type=template&id=e3922796&scoped=true&"
import script from "./review-affiliation.vue?vue&type=script&lang=tsx&"
export * from "./review-affiliation.vue?vue&type=script&lang=tsx&"
import style0 from "./review-affiliation.vue?vue&type=style&index=0&id=e3922796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3922796",
  null
  
)

export default component.exports